import { useEffect, useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SelectField from '../FormLegacy/FormFieldsV2/SelectField'
import api from '../../api/api'

import { getSurveyAnalyticsPeriods, transformSurveyData, addPercentSign } from './helpers'
import SatisfactionSurveyAnalytics from './SatisfactionSurveyAnalytics'
import ChoiceSurveyAnalytics from './ChoiceSurveyAnalytics'

const SurveyAnalytics = ({ buildingId, isOpen = true }) => {
  const { t } = useTranslation(['surveys'])
  const surveyAnalyticsPeriods = getSurveyAnalyticsPeriods(t)
  const [period, setPeriod] = useState(surveyAnalyticsPeriods[0].value)
  const [analytics, setAnalytics] = useState([])

  const fetchAnalytics = async () => {
    try {
      if (buildingId) {
        const toDate = new Date().getTime()
        const fromDate = toDate - period
        const data = await api.getSurveyAnalytics(buildingId, fromDate, toDate)

        setAnalytics(transformSurveyData(data.data))
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (isOpen) fetchAnalytics()
  }, [period, buildingId, isOpen])

  return (
    <div className="ctp-survey__box">
      <SelectField
        name="analytics"
        additionalClass="ctp-survey__analytics-select"
        selectStyle={{ width: '150px' }}
        options={surveyAnalyticsPeriods}
        onChange={(e) => setPeriod(e.target.value)}
        value={period}
      />
      <div className="ctp-survey__analytics">
        {analytics.length ? (
          <Fragment>
            {analytics.map(({ type, sentSurveys, responses, responseRate }, index) => {
              if (type === 'NPS') {
                return (
                  <SatisfactionSurveyAnalytics
                    key={`${type}-${index}`}
                    sentSurveys={sentSurveys}
                    responses={responses}
                    responseRate={responseRate}
                  />
                )
              } else {
                return (
                  <ChoiceSurveyAnalytics
                    key={`${type}-${index}`}
                    type={type === 'Single choice' ? 'single' : 'multiple'}
                    sent={sentSurveys}
                    responses={responses}
                    responseRate={addPercentSign(responseRate)}
                  />
                )
              }
            })}
          </Fragment>
        ) : (
          <div className="no-results">{t('surveys:analytics.noResults')}</div>
        )}
      </div>
    </div>
  )
}

SurveyAnalytics.propTypes = {
  buildingId: PropTypes.number,
  isOpen: PropTypes.bool,
}

export default SurveyAnalytics
